var THREE         = require("three");
var GlobalRotationHandleView  = require("./../abstract/globalRotationHandleView.js");
var lib_core      = require("lib-core");

var GlobalYRotationView = function (model, editorView, handleId, config) {
    GlobalRotationHandleView.call(this, model, editorView, handleId, config);
}

lib_core.inherit(GlobalYRotationView, GlobalRotationHandleView);

GlobalYRotationView.prototype.repositionMesh = function(mesh, position, rotation){
    var matrix = (new THREE.Matrix4())
    //matrix.makeRotationFromEuler(new THREE.Euler(rotation.x * Math.PI/180, 0, 0));
    matrix.setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

GlobalYRotationView.prototype.buildMesh = function(radius){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;

    var geom = this.buildSegGeometry(3).rotateX(Math.PI/2).rotateY(-Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    obj.add(mesh);
    return obj
}

GlobalYRotationView.prototype.hoverChanged = function(value){
    if(value){
        this.handleMesh.children[0].geometry = this.buildRingGeometry(3).rotateX(Math.PI/2).rotateY(-Math.PI/2); 
    } else {
        this.handleMesh.children[0].geometry = this.buildSegGeometry(3).rotateX(Math.PI/2).rotateY(-Math.PI/2); 
    }
} 

module.exports = GlobalYRotationView;

